import { Scale } from "@/animations/scale";
import Image from "@/components/Image";
import { cn } from "@/utils";
import { useResize } from "@/utils/useResize";
import { cva } from "class-variance-authority";
import clsx from "clsx";
import { Link } from "react-router-dom";
import { HeaderFinder } from "./header-finder";
import { WrapperFinder } from "./wrapper-finder";

const variants = cva("w-full", {
  variants: {
    twSize: {
      xs: "max-w-[80%] mr-[14px] mt-[32px]",
      sm: "max-w-[80%] mr-[14px] mt-[32px]",
      md: "max-w-[80%] mr-[14px] mt-[32px]",
      lg: "max-w-[555px] mr-[32px] mt-[32px]",
      xl: "max-w-[524px] mr-[88px] -mt-[220px]",
      "2xl": "max-w-[557px] mr-[94px] -mt-[215px]",
      "3xl": "max-w-[590px] mr-[97px] -mt-[221px]",
    },
  },
  defaultVariants: {
    twSize: "2xl",
  },
});

export function FinderBeraIsLand() {
  const { twSize } = useResize();

  return (
    <Scale>
      <div className="flex justify-end w-full">
        <WrapperFinder
          className={cn(variants({ twSize: twSize }), "overflow-hidden")}
        >
          <HeaderFinder>
            <p className="text-[#23262F] text-center text-[13px] font-medium leading-4 truncate">
              BeraIs.land
            </p>
          </HeaderFinder>

          <div
            className=" "
            style={{
              background:
                "linear-gradient(161deg, #301609 27.48%, #060706 97.22%)",
            }}
          >
            <div className="p-5">
              <p className="text-xl md:text-[1.75rem] md:leading-[2.5rem] font-medium">
                <span className="text-[#A3A8B5]">The first platform to</span>{" "}
                <span className="text-white">
                  trade, create, co-own AI Agents on Berachain, incubated by
                  Holdstation
                </span>
              </p>
            </div>
            <div>
              <Image
                src={require("@/assets/bg/bg_bersland.png")}
                alt="BeraIs.land"
                width={599}
                height={306}
              />
            </div>

            <div
              className={clsx(
                "grid grid-cols-[40px_1fr_126px] md:grid-cols-[48px_1fr_142px] gap-2.5 lg:gap-4 p-4",
                "p-4 border-t border-white/15 bg-black/10"
              )}
            >
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl flex-shrink-0">
                <Image
                  src={require("@/assets/icons/ic_bera_is_land.png")}
                  className="w-full h-full object-cover"
                  alt="close"
                  width={144}
                  height={144}
                />
              </div>

              <div className="flex-1">
                <p className="text-sm font-medium text-white line-clamp-1">
                  Bera Is.land
                </p>
                <p className="text-sm font-medium text-white/60 line-clamp-1">
                  BerAIs.land
                </p>
              </div>
              <div className="flex items-center justify-end">
                <Link
                  className={clsx(
                    "px-6 py-2.5 rounded-full bg-white relative z-10 text-sm text-[#141416] font-medium whitespace-nowrap"
                  )}
                  to={"https://www.berais.land"}
                  target="_blank"
                  data-action="redirect_berais.land"
                >
                  Explore
                </Link>
              </div>
            </div>
          </div>
        </WrapperFinder>
      </div>
    </Scale>
  );
}
